import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconForwardComponent } from "./med-icon-forward.component";

@NgModule({
  declarations: [
    MedIconForwardComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconForwardComponent,
  ],
})
export class MedIconForwardModule { }
